var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup11659(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50.5,
    r: 50,
    fill: "#4E4F54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 76H22.5",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 33.5V63.5C55 64.8807 56.1193 66 57.5 66H70C71.3807 66 72.5 64.8807 72.5 63.5V33.5C72.5 32.1193 71.3807 31 70 31H57.5C56.1193 31 55 32.1193 55 33.5Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 18.5H30C28.6193 18.5 27.5 19.6193 27.5 21V63.5C27.5 64.8807 28.6193 66 30 66H42.5C43.8807 66 45 64.8807 45 63.5V21C45 19.6193 43.8807 18.5 42.5 18.5Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11659);
export default __webpack_public_path__ + "static/media/Group 11659.33ed918dfd5ed8b6538bf029f2227db5.svg";
export { ForwardRef as ReactComponent };